import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import PageTitle from '../components/PageTitle';
import Card from '../components/Card';
import __ from '../utils/translator';
import remToPixels from '../utils/remToPixels';
import { useTheme } from 'styled-components';
import ManualStoreActions from "../flux/ManualStoreActions";
import ManualStore from "../flux/ManualStore";
import ChevronRight from "../icons/ChevronRight";
import PDFModal from "../components/PDFModal";
import themeResponsiveProperty
  from '../components/responsive/themeResponsiveProperty';
import CardTitle from '../components/CardTitle';
import Header from '../components/organisms/Header';

// @todo 2021-06-11 extract
function resizeCover(cover) {
  return cover.replace('0x0', `${remToPixels(0)}x${remToPixels(11)}`);
}

function isCollectionActive(collection) {
  return new Date(collection.closedAt) > new Date();
}

const manualCardStyle = {
  height: '8.3125rem',
  color: '#fff',
};

export default function MobileManuals() {
  const theme = useTheme();
  const [collections, setCollections] = useState([]);
  const [manualAsset, setManualAsset] = useState(null);

  useEffect(function() {
    const subscription = ManualStore.addListener(() => {
      setCollections(ManualStore.getState());
    });

    ManualStoreActions.getAll();

    return function() {
      subscription.remove();
    }
  }, []);

  return (
    <div>
      <Header />

      <PageTitle withTracking title="Merchandising manuals" />

      <Container>
        <SectionTitle>{__('Active')}</SectionTitle>

        <ManualsContainer>
          {collections !== null && collections.filter(collection => isCollectionActive(collection)).map(collection => (
            <div key={collection.id} style={{ marginBottom: '1.125rem' }}>
              <Card
                cover={resizeCover(collection.cover)}
                style={manualCardStyle}
              >
                <CardTitle>{collection.name}</CardTitle>
              </Card>

              <div>
                {collection.manuals.map(manual => (
                  <ManualItem key={manual.id} onClick={() => setManualAsset(manual)}>
                    <span>{manual.name}</span>
                    <ChevronRight />
                  </ManualItem>
                ))}
              </div>
            </div>
          ))}
        </ManualsContainer>

        <SectionTitle>{__('Archive')}</SectionTitle>

        <ManualsContainer>
          {collections !== null && collections.filter(collection => ! isCollectionActive(collection)).map(collection => (
            <div key={collection.id} style={{
              marginBottom: '1.125rem',
              opacity: '.5',
            }}>
              <Card
                cover={resizeCover(collection.cover)}
                style={manualCardStyle}
              >
                <CardTitle>{collection.name}</CardTitle>
              </Card>
              <div>
                {collection.manuals.map(manual => (
                  <ManualItem key={manual.id} onClick={() => setManualAsset(manual)}>
                    <span>{manual.name}</span>
                    <ChevronRight />
                  </ManualItem>
                ))}
              </div>
            </div>
          ))}
        </ManualsContainer>
      </Container>

      {manualAsset !== null && (
        <PDFModal
          isMobile={true}
          asset={manualAsset}
          onCloseButtonClick={() => setManualAsset(null)}
          onPdfLoad={() => {
            ManualStoreActions.manualLoad(manualAsset.id, manualAsset.collectionId)
          }}
        />
      )}
    </div>
  );
}

const Container = styled.div`
  position: relative;
  padding-top: ${themeResponsiveProperty('1rem', null)};
`;

const ManualsContainer = styled.div`
  max-width: 47.5rem;
  margin-right: auto;
  margin-left: auto;
  padding-top: .75rem;
  padding-right: 1.25rem;
  padding-left: 1.25rem;
`;

const ManualItem = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .75rem 1.125rem;
  background-color: #000;
  border-bottom: .0625rem solid #fff;
  color: #fff;
  font-weight: bold;
  font-size: .875rem;

  > svg {
    height: 1rem;
  }
`;

const SectionTitle = styled.h3`
  margin: 0;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  font-weight: bold;
`;
